import React, {
  Component
} from 'react';


class ProgressionBar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      progression: 0,
      displayed: true
    }
  }

  componentDidMount() {
    this.setProgression();
    window.addEventListener('scroll', () => this.setProgression());
    window.addEventListener('mousewheel', () => this.setProgression());
    window.addEventListener('resize', () => this.setProgression());
  }

  setProgression(){
    let windowHeight = window.innerHeight;
    let scrollTop = window.scrollY || window.pageYOffset;
    let pageHeight = document.body.offsetHeight;
    //let headerHeight = document.querySelector('header').offsetHeight;
    let progression;

    /*if(document.querySelector('.middle-page') == null){
      progression = scrollTop / (pageHeight - windowHeight)*100;
    }
    else{
      let middlePageTop = document.querySelector('.middle-page').offsetTop;
      progression = (scrollTop + headerHeight) > middlePageTop ?  (((scrollTop - middlePageTop + headerHeight) / (pageHeight - windowHeight - middlePageTop + headerHeight))*100) : 0;
    }*/

    progression = scrollTop / (pageHeight - windowHeight)*100;

    this.setState({
      progression: progression
    });
  }

  render() {
    return <div>
      { this.state.displayed &&
        <div className="progression-bar">
          <div className="progression" style={{width : this.state.progression+"%"}}></div>
        </div>
      }
    </div>
  }
}

export default (ProgressionBar)


// WEBPACK FOOTER //
// ./resources/assets/frontend/js/components/ProgressionBar.js